import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import UserSource from 'sources/UserSource';
import {List} from 'immutable';
import {AvatarSource} from 'sources/AvatarSource';
import User, {UserId} from 'records/User';
import {ActionsBase, DispatchAll} from '@store/@types/alt';

interface AsyncActions {
  fetchAll: (params: any) => Promise<List<User>>;
  fetchManager: (params: any) => Promise<User>;
  fetchManagersAndCoaches: () => Promise<List<User>>;
  fetch: (params: any) => Promise<List<User>>;
  uploadAvatar: (userId: UserId, file: File) => Promise<void>;
}

interface SyncActions {
  // TODO type these
  fetchError;
  fetchSuccess;
  fetchUsers;
}

class UserActions
  extends ActionsBase<AsyncActions, SyncActions>()
  implements DispatchAll<AsyncActions>
{
  constructor() {
    super();
    this.generateActions(
      'fetchError',
      'fetchSuccess',
      'fetchUsers',
      ...generateAsyncActions(
        'fetchAll',
        'fetchManager',
        'fetchManagersAndCoaches',
        'fetch',
        'uploadAvatar'
      )
    );
  }

  fetch(params) {
    return dispatch => {
      dispatch(params);
      // TODO cancel config? But probably better -- nuke this so we can stop calling python.
      return UserSource.fetch(params, {});
    };
  }

  // Should be preferred way for fetching users (vs `fetchUsers`)
  // Allows fetching all users and more sane/flexible params for filtering
  fetchAll(params) {
    return dispatch => {
      dispatch(params);
      return UserSource.fetchAll({
        ...params,
        ids: params && params.ids ? List(params.ids).toSet() : undefined,
      }).then(this.fetchAllSuccess, this.fetchAllError);
    };
  }

  fetchManagersAndCoaches() {
    return dispatch => {
      dispatch();
      return UserSource.fetchManagersAndCoaches().then(
        // Reuse fetchAll callbacks.
        this.fetchAllSuccess,
        this.fetchAllError
      );
    };
  }

  fetchManager(params) {
    return dispatch => {
      dispatch(params);
      return UserSource.fetchManager(params).then(this.fetchManagerSuccess, this.fetchManagerError);
    };
  }

  uploadAvatar(userId, file) {
    return dispatch => {
      dispatch();
      return AvatarSource.uploadAvatar(userId, file).then(
        url => this.uploadAvatarSuccess(userId, url),
        this.uploadAvatarError
      );
    };
  }
}

export default alt.createActions<AsyncActions, SyncActions>(UserActions);
